import React, { useState, useEffect } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { useNavigate, useLocation } from "react-router-dom";

export default function IPOListingSupport() {
  const navigate = useNavigate();
  const location = useLocation();
  const [activeTab, setActiveTab] = useState("");

  useEffect(() => {
    const currentPath = location.pathname;
    if (currentPath === "/depository-participant-audit") setActiveTab("dp");
    else if (currentPath === "/system-audit-capital-market")
      setActiveTab("system");
    else if (currentPath === "/exchange-sebi-compliances")
      setActiveTab("exchange");
    else if (currentPath === "/ipo-listing-support") setActiveTab("ipo");
    else if (currentPath === "/capital-market-sebi") setActiveTab("capital");
  }, [location.pathname]);

  const handleTabClick = (tab, path) => {
    setActiveTab(tab);
    navigate(path);
  };

  return (
    <>
      <Header />

      {/* ===== HERO SECTION ===== */}
      <section
        className="about-hero"
        style={{
          backgroundImage: "url('/assets/img/Achievements.jpg')",
        }}
      >
        <div className="overlay"></div>
        <div className="about-hero-text">
          <h1>IPO & Listing Support</h1>
          <p>
            End-to-end guidance and compliance support for companies planning to
            raise capital and get listed on stock exchanges.
          </p>
        </div>
      </section>

      {/* ===== TABS SECTION ===== */}
      <div className="tax-tabs">
        <button
          className={activeTab === "capital" ? "active" : ""}
          onClick={() => handleTabClick("capital", "/capital-market-sebi")}
        >
          Capital Market & SEBI Advisory
        </button>

        <button
          className={activeTab === "dp" ? "active" : ""}
          onClick={() => handleTabClick("dp", "/depository-participant-audit")}
        >
          Depository Participant (DP) Audit – NSDL/CDSL
        </button>

        <button
          className={activeTab === "system" ? "active" : ""}
          onClick={() =>
            handleTabClick("system", "/system-audit-capital-market")
          }
        >
          System Audit for Capital Market Intermediaries
        </button>

        <button
          className={activeTab === "exchange" ? "active" : ""}
          onClick={() =>
            handleTabClick("exchange", "/exchange-sebi-compliances")
          }
        >
          Exchange & SEBI Compliances
        </button>

        <button
          className={activeTab === "ipo" ? "active" : ""}
          onClick={() => handleTabClick("ipo", "/ipo-listing-support")}
        >
          IPO & Listing Support
        </button>
      </div>

      {/* ===== CONTENT SECTION ===== */}
      <section className="container py-5">
        <h2 className="section-title mb-4">IPO & Listing Support</h2>
        <p className="service-text mb-5">
          A public listing is a significant milestone that enables companies to
          raise capital, enhance market credibility, and support long-term
          business growth. However, the IPO process involves complex regulatory
          requirements, extensive documentation, and strict compliance with SEBI
          and stock exchange regulations. At <strong>S D P M & Co.</strong>, we provide
          comprehensive IPO and Listing Advisory Services to companies planning
          to list on the SME <strong> Exchange or Mainboard (NSE/BSE).</strong> Our team assists
          organizations at every stage of the IPO lifecycle—from initial
          eligibility assessment and structuring to regulatory compliance and
          post-listing governance—ensuring a smooth and well-prepared listing
          journey.
        </p>

        <div className="row g-4">
          {/* Card 1 */}
          <div className="col-md-6">
            <div className="dp-card">
              <h4>SME & Mainboard IPO Advisory</h4>
              <p>We assist with:</p>
              <ul>
                <li>Eligibility assessment</li>
                <li>Proper structuring of share capital</li>
                <li>IPO planning & coordination</li>
                <li>Merchant banker and legal advisor alignment</li>
              </ul>
            </div>
          </div>

          {/* Card 2 */}
          <div className="col-md-6">
            <div className="dp-card">
              <h4>Pre-IPO Due Diligence & Documentation</h4>
              <p>We review and prepare:</p>
              <ul>
                <li>Financial statements</li>
                <li>Secretarial records</li>
                <li>Tax compliance</li>
                <li>Corporate governance documentation</li>
                <li>Contracts & legal papers</li>
              </ul>
              {/* <p>We help build a due-diligence-ready organisation.</p> */}
            </div>
          </div>

          {/* Card 3 */}
          <div className="col-md-6">
            <div className="dp-card">
              <h4>Post-Listing Quarterly / Half-Yearly Compliances</h4>
              <p>After listing, we support with:</p>
              <ul>
                <li>Shareholding pattern filings</li>
                <li>Corporate announcements</li>
                <li>Board meeting & disclosure compliances</li>
                <li>Half-yearly & annual reports</li>
                <li>Event-based disclosures under SEBI LODR</li>
              </ul>
            </div>
          </div>

          {/* Card 4 */}
          <div className="col-md-6">
            <div className="dp-card">
              <h4>Corporate Governance & SEBI LODR Compliances</h4>
              <p>We help implement:</p>
              <ul>
                <li>Board composition norms</li>
                <li>Committee formation (Audit, NRC, CSR)</li>
                <li>
                  Policy documentation (Vigil Mechanism, Insider Trading, etc.)
                </li>
                <li>Disclosure management system</li>
                <li>LODR compliance calendar</li>
              </ul>
            </div>
          </div>

          {/* Card 5 */}
        </div>
      </section>
      {/* <div className="col-md-12">
        <div className="nri-highlight ">
          <h3 className="mb-3"> Why Choose Us?</h3>
          <ul>
            <li>Strong experience in SME & Mainboard listings</li>
            <li>Complete regulatory handholding</li>
            <li>Accurate documentation & compliance framework</li>
            <li>Assistance from planning to post-IPO governance</li>
          </ul>
        </div>
      </div> */}

      <Footer />
    </>
  );
}
